import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import ImageSliderStandard from 'components/consumer/image-slider-standard';
import useScreen from 'hooks/useScreen';
import IconCamera from '../../../../icons/iconCamera';

const PDPCustomerPhotosGridUI = ({ photos, totalPhotos, onPhotoClick }) => {
  const { isMobile, isDesktop } = useScreen();

  if (!photos || !photos.length) return null;
  const items = photos.slice(0, 5);

  const children = items.map((photo, idx) => (
    <div
      key={photo.id}
      className={cx({
        'flex-[1_1_0%] min-w-[75%] pr-5': isMobile,
        'col-start-1 col-end-3 row-start-1 row-end-3':
          items.length !== 3 && !isMobile && idx === 0,
        'col-start-1 col-end-4': items.length === 3 && !isMobile && idx === 0,
        'col-start-3 col-end-5': items.length === 4 && !isMobile && idx === 1,
        'col-start-3 col-end-5 row-start-1 row-end-3':
          items.length === 2 && !isMobile && idx === 1,
      })}
    >
      <div
        className={cx({
          'h-0 mb-0 overflow-hidden pt-[100%] relative [&_img]:absolute [&_img]:inset-0 [&_img]:w-full [&_img]:h-full': isMobile,
          'w-full h-full': !isMobile,
        })}
      >
        {photos.length > 5 && idx === 4 ? (
          <button
            type="button"
            className={cx(
              'w-full h-full flex cursor-pointer items-center justify-center flex-col bg-brand-lightest transition-[background-color_.15s_ease] [&_svg_g]:fill-brand hover:bg-brand-lighter',
              {
                'absolute inset-0': isMobile,
              }
            )}
            onClick={onPhotoClick}
          >
            <div>
              <IconCamera />
            </div>
            {totalPhotos > 4 && (
              <div className="text-xs text-brand">+{totalPhotos - 4} more</div>
            )}
          </button>
        ) : (
          <JBImage
            sizes="50vw"
            src={photo.url}
            ar="1:1"
            fit="crop"
            trim="auto"
            onClick={() => onPhotoClick(idx)}
            className={cx({
              rounded: isMobile,
              'hover:cursor-target': isDesktop,
            })}
          />
        )}
      </div>
    </div>
  ));

  if (isMobile) {
    return (
      <div className="max-[767px]:-ml-5 max-[767px]:-mr-5">
        <ImageSliderStandard
          config={{
            children,
            sliderConfig: {
              navType: 'Button',
              visibleSlides: 2,
              imageWidth: 150,
              infinite: false,
            },
            variation: { value: 'Component' },
          }}
          fullWidth
        />
      </div>
    );
  }

  return (
    <div className="grid gap-[.5rem] mt-4 mb-2 grid-cols-[repeat(4,calc(25%_-_.5rem)_)] grid-rows-[repeat(2,100px)] justify-center content-end [content-visibility:auto] [contain-intrinsic-size:0]">
      {children}
    </div>
  );
};

PDPCustomerPhotosGridUI.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      url: PropTypes.string,
    })
  ),
  totalPhotos: PropTypes.number,
  onPhotoClick: PropTypes.func,
};

export default PDPCustomerPhotosGridUI;
